import React, { Component } from 'react'
import { Segment, Form } from 'semantic-ui-react'

const REPORT_TYPE_OPTIONS = [
    { key: 'audit', text: 'Audit', value: 'Audit' },
    { key: 'tax', text: 'Tax', value: 'Tax' },
    { key: 'fs', text: 'FS', value: 'FS' },
    { key: 'xbrl', text: 'XBRL', value: 'XBRL' }
]

class ReportCaseIntakeSection extends Component {
    buildUserOptions() {
        const users = this.props.users || []
        return users.map(u => ({
            key: u._id,
            text: u.name || u.email,
            value: u._id
        }))
    }

    render() {
        const { values, onChange } = this.props

        return (
            <Segment>
                <Form>
                    <Form.Group widths='equal'>
                        <Form.Input
                            type='date'
                            label='Email Received On'
                            value={toDateInput(values.emailReceivedOn)}
                            onChange={(e) => onChange('emailReceivedOn', e.target.value)}
                        />

                        <Form.Select
                            search
                            label='Person In Charge'
                            placeholder='Select user'
                            options={this.buildUserOptions()}
                            value={values.personInCharge || ''}
                            onChange={(e, { value }) => onChange('personInCharge', value)}
                        />
                    </Form.Group>

                    <Form.Group widths='equal'>
                        <Form.Dropdown
                            fluid
                            multiple
                            selection
                            search
                            label='Report Types'
                            placeholder='Select report types'
                            options={REPORT_TYPE_OPTIONS}
                            value={values.reportTypes || []}
                            onChange={(e, { value }) => onChange('reportTypes', value)}
                        />

                        <Form.Input
                            label='FYE / Period'
                            placeholder='e.g. 2025/12 or 31-12-2025'
                            value={values.fye}
                            onChange={(e) => onChange('fye', e.target.value)}
                        />
                    </Form.Group>

                    <Form.Checkbox
                        label='XBRL Service'
                        checked={!!values.xbrlService}
                        onChange={(e, { checked }) => onChange('xbrlService', checked)}
                    />

                    <Form.TextArea
                        label='Printing / Processing Instructions'
                        value={values.instructions}
                        onChange={(e) => onChange('instructions', e.target.value)}
                    />
                </Form>
            </Segment>
        )
    }
}

function toDateInput(d) {
    if (!d) return ''
    const date = new Date(d)
    if (Number.isNaN(date.getTime())) return ''
    return date.toISOString().slice(0, 10)
}

export default ReportCaseIntakeSection